import { List, ListItemButton as ListItemButtonMui, Stack, styled } from "@mui/material";
import { Run } from "..";
import type { Flow } from "../../graphql/types";
const ListItemButton = styled(ListItemButtonMui)(({ theme }) => ({
  marginTop: theme.spacing(2),
  backgroundColor: theme.palette.surfaceLight10.main,
  height: "auto",
  borderRadius: "4px",
  border: `1px solid ${theme.palette.surfaceLight30.main}`,
  ".meditation_id": {
    display: "none",
  },
  "&:hover .meditation_id": {
    display: "flex",
  },
}));

const RunList = ({ entries, bigSize }: { entries: Flow[]; bigSize: boolean }) => {
  return (
    <Stack sx={{ justifyContent: "center", alignItems: "center" }}>
      <List sx={{ width: "90%", mt: 2 }}>
        {entries.map((test, index) => (
          <div className="TestRuns" key={index}>
            <ListItemButton disableRipple key={index} data-cy="testRuns-list">
              <Run test={test} bigSize={bigSize} />
            </ListItemButton>
          </div>
        ))}
      </List>
    </Stack>
  );
};

export { RunList };
